import AppContainer from '~/containers/AppContainer/AppContainer';
import Head from 'next/head';
import React from 'react';
import { VinovestExchange } from '~/components/views/Trading/VinovestExchange';
import { WineGoals } from '~/components/views/Trading/WineGoals';
import { TradingBenefits } from '~/components/views/Trading/TradingBenefits';
import { FAQ } from '~/components/views/Trading/FAQ';

export default function TradingPage() {
    return (
        <AppContainer>
            <Head>
                <title>Trading Wine with Vinovest</title>
                <meta
                    name={'description'}
                    content={'Learn how to trade wine with Vinovest and explore the world of fine wine investment.'}
                />
            </Head>
            <VinovestExchange />
            <WineGoals />
            <TradingBenefits />
            <FAQ />
        </AppContainer>
    );
}
